export type BestOf = 1 | 3 | 5;
export type PointsPerGame = number; // validated at runtime boundaries
export type DeuceRule = 'win_by_2' | 'sudden_death';

export interface GameFormat {
  bestOf: BestOf;
  pointsPerGame: PointsPerGame;
  /** Alternate target for the final possible game; null/omitted inherits at configuration scopes. */
  decidingGamePoints?: number | null;
  deuceRule?: DeuceRule;
  estimatedMatchDurationMinutes?: number;
}

export const POINTS_PRESETS = [11, 15] as const;
export const POINTS_PER_GAME_MIN = 1;
export const POINTS_PER_GAME_MAX = 99;
export const DEFAULT_POINTS_PER_GAME: PointsPerGame = 11;
export const DEFAULT_DEUCE_RULE: DeuceRule = 'win_by_2';

export function isValidPointsPerGame(n: unknown): n is number {
  return (
    typeof n === 'number' &&
    Number.isInteger(n) &&
    n >= POINTS_PER_GAME_MIN &&
    n <= POINTS_PER_GAME_MAX
  );
}
